// extracted by mini-css-extract-plugin
module.exports = {"root":"rive-tier-module--root--rLDQY","riveContainer":"rive-tier-module--riveContainer--duLWP","cursorHidden":"rive-tier-module--cursorHidden--nkkQn"};